module["exports"] = [
  "AG",
  "GmbH",
  "und Söhne",
  "und Partner",
  "& Co.",
  "Gruppe",
  "LLC",
  "Inc."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/company/suffix.js
// module id = 971
// module chunks = 0